import { App } from '@fuxi/eevee-ui';
// 提供可消费 React context 的 message.xxx、Modal.xxx、notification.xxx 的静态方法，可以简化 useMessage 等方法需要手动植入 contextHolder 的问题。

export const useAntStaticComponent = () => {
  const { message, notification, modal } = App.useApp();

  return { message, notification, modal };
};

export default useAntStaticComponent;
